
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
              <div class="card" style="box-shadow: 0 0 5px gray;">
                <div class="card-body">
                    <form @submit.prevent="AddtoCart">
                    <div class="form-group mb-2">
                        <label>Expense Category</label>
                        <multiselect v-model="category" @input="FilterCategory" label="name" :options="expensecategories"></multiselect>
                      </div>
                      <div class="form-group mb-2">
                      <label>Expense Item</label>
                        <multiselect v-model="expenseitem" label="name" :options="expenseitems"></multiselect>
                      </div>
                      <div class="form-group mb-2">
                        <label>Expense Amount</label>
                        <input v-model="amount" type="number" class="form-control" />
                      </div>
                      <div class="form-group mb-2">
                        <label>Description</label>
                        <textarea v-model="description"  type="text" class="form-control"/>
                      </div>
                      <div class="form-group">
                    <button class="btn btn-primary w-100" :class="{ disabled: loader}"><span v-if="loader"><b-spinner small/></span>
                      <span v-else><i class="fas fa-check-circle"></i> Submit</span></button>
                    </div>
                    </form>
                </div>
              </div>
              </div>
              <div class="col-md-8">    
                <div class="card" style="box-shadow: 0 0 2px gray;">
                  <span v-if="this.expensecarts.length<=0">
                    <div class="d-flex justify-content-center p-5">
                    <span class="mdi mdi-cash text-success display-5"></span><br>
                    <span class="h4 mt-4">No Item Selected</span>
                  </div>
                  </span>
                  <span v-else>
                    <div class="table-responsive">
                      <b-table
                        :items="Items"
                        :fields="Fields"
                        responsive="sm"
                        :busy="IsBusy"
                      >
                      <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                      <template #cell(index)="data">
                        {{ data.index + 1 }}
                      </template>
                      <template #cell(expense)="data">
                        {{ data.item.expense.name }}
                      </template>
                      <template #cell(category)="data">
                        {{ data.item.category.name }}
                      </template>
                      <template #cell(actions)="data">
                        <b-button @click="remove(data.item.id,data.item.expense.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                      </template>
                      </b-table>
                    </div>
                    <div class="row mx-1">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Total</label>
                          <input v-model="cart_total" type="number" readonly class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Amount Paid</label>
                          <input v-model="amountpaid" type="number" required class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Payment Option</label>                        
                          <multiselect v-model="payoption" label="name" :options="paymentoptions"></multiselect>
                        </div>
                      </div>
                      <div class="col-md-4 mb-2">
                        <div class="form-group">
                          <label>Pay Date</label>
                          <input v-model="paydate" type="date" required class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-4"></div>
                      <div class="col-md-4">
                          <b-button class="btn w-100 mt-4 mb-2" @click="SubmitExit" variant="primary"><i class="mdi mdi-check-circle"></i> SUBMIT & EXIT</b-button>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="delete-cart" centered title="Delete From Cart" title-class="font-18" hide-footer>
          <form @submit.prevent="removeFromCart">
              <input v-model="id" type="hidden">
                Are you sure you want to remove the Expense : <b>{{ expense }}</b> ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-cart')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal> 
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";

import { 
  expensecartMethods, expensecartComputed,
  paymentoptionMethods, paymentoptionComputed,
  expenseCategoryMethods, expenseCategoryComputed 
} from "@/state/helpers";


export default {
  page: {
    title: "Record Expense",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Record Expense",
      items: [{text: "Dashboard",href: "/"},{text: "Expenses",active: true}],
      isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'category', label: 'Category', visible: true },
            { key: 'expense', label: 'Expense Name', visible: true },
            { key: 'amount', label: 'Amount', visible: true },
            { key: 'description', label: 'Description', visible: true },
            { key: 'actions', label: 'Remove', visible: true },
          ],
      id:'',
      expense:'',
      expenseitems: [],
      expenseitem: "",
      category: "",
      description: "",
      amount: "",
      paydate:new Date().toLocaleDateString('fr-CA'),
      payoption:'',
      loader:false,
      amountpaid:0,
    };
  },
  methods: {
    ...expensecartMethods,
    ...expenseCategoryMethods,
    ...paymentoptionMethods,
  async FilterCategory(){
      let url = `/findexpenseitems/${this.category.id}`;
      await axios.get(url).then((response) => {
        this.expenseitems = response.data.items;
      });
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
      remove(id,expense){
        this.id=id;
        this.expense=expense;
        this.$bvModal.show('delete-cart')
      },
    async AddtoCart() { 
        this.loader=true;
        let formData = new FormData();
        formData.append("category", this.category.id);
        formData.append("item", this.expenseitem.id);
        formData.append("amount", this.amount);
        formData.append("amountpaid",this.amountpaid);
        formData.append("total", this.cart_total);
        formData.append("total",this.total);
        formData.append("description", this.description);
        let url = "/addexpensecart";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.payoption = this.paymentoptions.find(option => option.set_default == 1);
            this.fetchExpenseCart();
            this.category="";
            this.expenseitem="";
            this.amount="";
            this.description="";
            this.loader=false;
        }
        });
      },
      async removeFromCart() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/deleteexpensecart";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchExpenseCart();
          this.$bvModal.hide('delete-cart');
        }
      });
      },
      async SubmitExit(){
        let obj = {
          cart:this.Cart,
          // amount:this.amountpaid,
          // total:this.cart_total,
          amount: this.amountpaid, // Total amount paid
      total: this.cart_total,
          payoption:this.payoption.id,
          paydate:this.paydate
         }
        let url = "/saveexpensecart";
        await axios.post(url, obj).then((response) => {
          if (response.status == 200) {
            this.fetchExpenseCart();
          }
        });
      },

  },
  computed: {
    ...expensecartComputed,
    ...expenseCategoryComputed,
    ...paymentoptionComputed, 
    cart_total(){ var total = 0; this.expensecarts.forEach((item)=>{ var item_total = item.amount; total = Number(total)+Number(item_total);}); return total },
    // amountpaid(){ var total = 0; this.expensecarts.forEach((item)=>{ var item_total = item.amount; total = Number(total)+Number(item_total);}); return total },
    List() { return this.expensecarts.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.expensecarts.map((d) => ({...d }))},
    Cart() { return this.expensecarts.map((d) => ({id:d.id,category:d.category.id,expense:d.expense.id,amount:d.amount,description:d.description }))},
    IsBusy() { let a=false; if (this.expensecarts.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchExpensecategories();
    this.fetchExpenseCart();
    this.fetchPaymentoptions();
    this.isBusy=false;
    this.payoption = this.paymentoptions.find(option => option.set_default == 1);
  },
};
</script>
